import { getNumArray } from "@/lib/chillnn/get-num-array";
import {
	BillingTypeTarget,
	BillingTypeTerm,
	BillingTypeTermValidation,
	CurrencyType,
	type AdditionalFeeItemInput,
} from "@/lib/gql/__generated__/graphql";

import type { ForAutoGenerator } from "@/components/features/_model/types/auto-generator-for-view-model";

import type { FormOptionType } from "@/components/ui/form/_types/type";

export const DEFAULT_ADDITIONAL_FEE = (uuid: string) => {
	return {
		additionalID: {
			isEdited: true,
			value: uuid,
		},

		name: {
			isEdited: true,
			value: "",
		},

		isExcludeCancelFeeTarget: {
			isEdited: false,
			value: false,
		},
		isNotDiscountTarget: {
			isEdited: false,
			value: false,
		},
		isNotTargetOnDayTrip: {
			isEdited: false,
			value: false,
		},
		isExcludedConsumptionTax: {
			isEdited: false,
			value: false,
		},

		billingTypeTarget: {
			isEdited: false,
			value: BillingTypeTarget.Room,
		},
		billingTypeTerm: {
			isEdited: false,
			value: BillingTypeTerm.PerReservation,
		},
		price: {
			amount: {
				isEdited: false,
				value: 0,
			},
			currencyType: {
				isEdited: false,
				value: CurrencyType.Jpy,
			},
		},

		kidsPrices: undefined,
		useKidsPrice: {
			isEdited: false,
			value: false,
		},

		billingTypeTermValidation: {
			isEdited: false,
			value: BillingTypeTermValidation.Ordinary,
		},
		termValidationApplyStartDt: undefined,
		termValidationApplyEndDt: undefined,
	} satisfies ForAutoGenerator<AdditionalFeeItemInput, "">;
};

export const billingTypeTargetOptions = [
	{
		id: "billingTypeTargetOptions_0",
		label: "１人あたり",
		value: BillingTypeTarget.Person,
	},
	{
		id: "billingTypeTargetOptions_1",
		label: "１部屋あたり",
		value: BillingTypeTarget.Room,
	},
	{
		id: "billingTypeTargetOptions_2",
		label: "１団体あたり",
		value: BillingTypeTarget.Group,
	},
] satisfies FormOptionType[];

export const billingTypeTermOptions = [
	{
		id: "billingTypeTermOptions_0",
		label: "１泊ごとに",
		value: BillingTypeTerm.PerDate,
	},
	{
		id: "billingTypeTermOptions_1",
		label: "宿泊を通して",
		value: BillingTypeTerm.PerReservation,
	},
] satisfies FormOptionType[];

export const billingTypeTermValidationOptions = [
	{
		id: "billingTypeTermValidationOptions_0",
		label: "常に適用する",
		value: BillingTypeTermValidation.Ordinary,
	},
	{
		id: "billingTypeTermValidationOptions_1",
		label: "毎年特定の期間に適用する",
		value: BillingTypeTermValidation.LimitedAnnually,
	},
] satisfies FormOptionType[];

export const consumptionTaxOptions = [
	{
		id: "consumptionTaxOptions_0",
		label: "税込",
		value: "false",
	},
	{
		id: "consumptionTaxOptions_1",
		label: "非課税にする（宿泊税など）",
		value: "true",
	},
] satisfies FormOptionType[];

export const kidsAgeOptions = getNumArray(0, 1, 20).map((num) => {
	return {
		id: `kidsAgeOptions_${num}`,
		label: `${num}歳`,
		value: String(num),
	} satisfies FormOptionType;
}) satisfies FormOptionType[];
